<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
  name: 'FullscreenLayout',
};
</script>

<style scoped>

</style>
